import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';

import { APP_ROUTES } from '@/shared/config/routes-config';
import { UserRole } from '@/shared/enums/user-role.enum';
import { RouteConfig } from '@/shared/interfaces/routes-config.interface';
import DefaultLayout from '@/shared/layouts/default/default.layout';

const ServiceCenterProductsListContainer = React.lazy(
  () => import('../../containers/list/service-center-products-list.component')
);

const ServiceCenterProductAddContainer = React.lazy(
  () => import('../../containers/add/service-center-products-add.component')
);

const ServiceCenterProductEditContainer = React.lazy(
  () => import('../../containers/edit/service-center-products-edit.component')
);

const ServiceCenterProductDetailsContainer = React.lazy(
  () => import('../../containers/details/service-center-products-details.component')
);

export const ServiceCenterProductsRoutesConfig: RouteObject[] = [
  {
    index: true,
    element: (
      <Navigate
        to={(APP_ROUTES.SERVICE_CENTER_PRODUCTS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH}
      />
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_PRODUCTS_MODULE.CHILDREN as RouteConfig).LIST.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterProductsListContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_PRODUCTS_MODULE.CHILDREN as RouteConfig).ADD.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterProductAddContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_PRODUCTS_MODULE.CHILDREN as RouteConfig).EDIT.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          addLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterProductEditContainer}
        />
      </React.Suspense>
    )
  },
  {
    path: (APP_ROUTES.SERVICE_CENTER_PRODUCTS_MODULE.CHILDREN as RouteConfig).DETAILS.FULL_PATH,
    element: (
      <React.Suspense fallback={<div>Loading...</div>}>
        <DefaultLayout
          authenticationRequired={true}
          permittedList={[UserRole.ADMIN]}
          component={ServiceCenterProductDetailsContainer}
        />
      </React.Suspense>
    )
  }
];
